import { render, staticRenderFns } from "./RoboServiceList.vue?vue&type=template&id=87ac2f20&scoped=true"
import script from "./RoboServiceList.vue?vue&type=script&lang=js"
export * from "./RoboServiceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ac2f20",
  null
  
)

export default component.exports